import { TENANT_REGIONS } from "../constants/tenantRegions";
import { store } from "../redux/store";

const STORAGE_URLS = {
  'dxb': process.env.REACT_APP_STORAGE_URL_DXB,
  'ksa': process.env.REACT_APP_STORAGE_URL_KSA,
};

export const getRegionalStorageURL = (tenant_id = null) => {
  if (!tenant_id) {
    let state = store.getState()
    let authData = state.auth.authData
    tenant_id = authData.centerData.tenant_id;
  }
  const region = TENANT_REGIONS[tenant_id] || 'dxb';
  return STORAGE_URLS[region] || STORAGE_URLS['dxb'];
};